import ErrorModal from './error-modal';

export default ErrorModal;
